import { useCallback, useRef } from 'react'
import { ResumeWorkExperience } from '@rio/types'
import { useI18n } from 'builder/hooks/useI18n'
import Select from 'builder/components/Select'
import { Field } from 'builder/components/Card/styles'

type Props = {
  item: ResumeWorkExperience
  updateSelect: (key: string, value: string) => void
}

export const ReasonForResignation = (props: Props) => {
  const { i18n } = useI18n()
  const { item, updateSelect } = props
  const Reasons = useRef({
    RETIREMENT: 'involuntary_retirement',
    PERSONAL_REASON: 'personal_reasons',
    NONE: null,
  })
  const options = useRef([
    { id: Reasons.current.NONE, name: '\0' },
    {
      id: Reasons.current.RETIREMENT,
      name: i18n.t(
        'builder.resume_editor.work_experience_section.resignation_options.involuntary_retirement',
      ),
    },
    {
      id: Reasons.current.PERSONAL_REASON,
      name: i18n.t(
        'builder.resume_editor.work_experience_section.resignation_options.personal_reasons',
      ),
    },
  ])

  const reason = item.reasonForResignation || ''
  const handleSelect = useCallback(
    (value: string | null) => {
      updateSelect('reasonForResignation', value || '')
    },
    [updateSelect],
  )

  return (
    <>
      <Field>
        <Select
          label={i18n.t('builder.resume_editor.work_experience_section.reason_for_resignation')}
          selected={reason}
          onSelect={handleSelect}
          options={options.current}
        />
      </Field>
    </>
  )
}
